import { render, staticRenderFns } from "./TabTrash.vue?vue&type=template&id=cc80004c&scoped=true&"
import script from "./TabTrash.vue?vue&type=script&lang=js&"
export * from "./TabTrash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc80004c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc80004c')) {
      api.createRecord('cc80004c', component.options)
    } else {
      api.reload('cc80004c', component.options)
    }
    module.hot.accept("./TabTrash.vue?vue&type=template&id=cc80004c&scoped=true&", function () {
      api.rerender('cc80004c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/TabTrash.vue"
export default component.exports